import capitalize from "../helpers/capitalize";

// Type for YAML-based service categories
export interface YamlServiceCategory {
  id: string;
  yamlId?: string;
  slug: string;
  name: string;
  label?: string;
  description?: string;
}

export default class ServiceCategory {
  id: string;
  yamlId?: string;
  slug: string;
  name: string;
  label: string;
  description: string;

  constructor(category: YamlServiceCategory) {
    this.id = category.id;
    this.yamlId = category.yamlId;
    this.slug = category.slug!;
    this.name = category.name!;
    this.label = category.label || capitalize(category.name!);
    this.description = category.description || "";
  }
}
